import { render, staticRenderFns } from "./AdminBreadView.vue?vue&type=template&id=26fd75f3&"
import script from "./AdminBreadView.vue?vue&type=script&lang=js&"
export * from "./AdminBreadView.vue?vue&type=script&lang=js&"
import style0 from "./AdminBreadView.vue?vue&type=style&index=0&id=26fd75f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports